module.exports=[
	{id:1,name:'html',status:false}	,
	{id:2,name:'css',status:false}	,
	{id:3,name:'javascript',status:false}	,
	{id:4,name:'dom',status:false}	,
	{id:5,name:'form',status:false}	,
	{id:6,name:'bom',status:false}	,
	{id:7,name:'direact functions',status:false}	,
	{id:8,name:'indirect functions',status:false}	,
	{id:9,name:'promise',status:false}	,
	{id:10,name:'async',status:false}	,
	{id:11,name:'await',status:false}	,
	{id:12,name:'defer',status:true}	
]